import React, { useEffect, useRef, useState } from "react";
import { fromUrlExcursionVendor } from "../../../../helper/vendorMask";
import moment from "moment";
import { ChevronDownIcon } from "../../../../helper/HwIconExcursion";
import { ChevronUpIcon , OpenDateIcon  } from "../../../../helper/HwIcon";
import { getTimeSlots } from "../getTimeSlots";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDateFormat, formatePriceFn, formatPrice } from "../../../../helper/commonFunction";
import { useSelector } from "react-redux";
import { getExcurstionDetails } from "../getExcurstionDetails";
import { useCancellationPolicy } from "../../checkout/useCancellationPolicy";
import { CancellationPolicy } from "../../checkout/components/CancellationPolicy";
const maxDescChars = 150;

const round2Slot = (n) => Math.round((Number(n) || 0) * 100) / 100;
const slotTaxBlock = (amount, vatRateType, rateMode) => {
  const a = Number(amount) || 0;
  if (String(vatRateType || "").toLowerCase() !== "standard-vat") {
    return { baseAmount: a, taxAmount: 0, finalAmount: a };
  }
  const tax = round2Slot(a * 0.05);
  if (String(rateMode || "").toLowerCase() === "inclusive-rate") {
    return { baseAmount: round2Slot(a - tax), taxAmount: tax, finalAmount: a };
  }
  return { baseAmount: a, taxAmount: tax, finalAmount: round2Slot(a + tax) };
};

const VariationItem = ({
  data,
  customProductTimeSlot,
  setFieldValue,
  fieldValue,
  variation,
  totalSelectedTicketCount,
  isAvailableTicketLessThanSelected,
  setSelectedVariation,
  selectedVariation,
  setLoadingAPI,
  loadingAPI
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { agentActiveCurrency,displayPrice } = useSelector((state) => state.userData);

  const checkoutContextParams = () => {
    const qp = new URLSearchParams(location.search);
    const params = new URLSearchParams({
      vendor: variation?.vendor ?? data?.vendor ?? fromUrlExcursionVendor(qp.get("vendor")) ?? "",
      "tour-id": variation?.tourId ?? qp.get("tour-id") ?? "",
      "contract-id": variation?.contractId ?? qp.get("contract-id") ?? "",
      "country-id": qp.get("country-id") ?? "",
      "city-id": qp.get("city-id") ?? "",
      "transfer-id": variation?.transferId ?? "",
      cId: data?.commonId ?? qp.get("cId") ?? "",
    });
    return params.toString();
  };
  const [toggleReadMore, setToggleReadMore] = useState({});
  const [selected,setSelected]=useState()
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const variationRefs = useRef([]);
  const errorMessageRef = useRef(null);
  const [helidubaipaxError,sethelidubaipaxError]=useState("")
  const [error,setError]=useState("")
  const [processingCheckout,setProcessingCheckout]=useState(false)
  const [fewTicketPrice,setFewTicketPrice]=useState({})

  const _setSelectedVariation = (d) => {
    // if(!d?.IsEventBased){
    //   setnotEventBased(d)
    //   setSelectedVariation(d);
    // }
    setSelectedVariation(d);
    // setLoadingAPI(true);
    setShowTimeSlots(false);
    setFieldValue({
      ...fieldValue,
      time: "",
    });
  };

  const {
    data: timeSlots,
    loading,
    refresh,
    refreshHeliDubaiSchedules,
    refreshUnifiedSlots,
    error: slotError,
    IsEventBased
  } = getTimeSlots(setLoadingAPI);
  const { createCheckoutSession, getAvailability } = getExcurstionDetails({ skipFetch: true })

  const slotVatType = {
    vatRateType: data?.vatRateType || timeSlots?.vatRateType,
    exclusiveOrInclusive: data?.exclusiveOrInclusive || timeSlots?.exclusiveOrInclusive,
  };
  const taxObj = btoa(
    encodeURIComponent(JSON.stringify({
       vatRateType : slotVatType.vatRateType , exclusiveOrInclusive : slotVatType.exclusiveOrInclusive
    }))
  );

  const isSelectedVariation =
    selectedVariation?.variation_unique_id === variation?.variation_unique_id;

  const {
    data: cancellationPolicy,
    loading: cancellationPolicyLoading,
    error: cancellationPolicyError,
  } = useCancellationPolicy({
    vendor: variation?.vendor ?? data?.vendor ?? "",
    excursionId: variation?.tourId ?? data?.singleId,
    contractId: variation?.contractId,
    tourOptionId: variation?.tourOptionId ?? variation?.variation_unique_id,
    travelDate: fieldValue?.selectDate,
    startTime: variation?.startTime ?? "",
    commonId: data?.commonId,
    enabled: isSelectedVariation && !!fieldValue?.selectDate,
  });

  const checkRaynaAvailability = async (startTime) => {
    const isRaynaVendor = variation?.vendor === "rayna" || data?.isRayna;
    const isParmarVendor = variation?.vendor === "parmar" || data?.isParmar;
    if (!isRaynaVendor && !isParmarVendor) {
      return { success: true };
    }
    if (isParmarVendor) {
      const result = await getAvailability(
        variation?.tourId ?? data?.singleId,
        moment(fieldValue.selectDate).format("YYYY-MM-DD"),
        fieldValue?.numberOfChild ?? 0,
        fieldValue?.numberOfAdults ?? 1,
        fieldValue?.numberOfInfants ?? 0,
        {
          vendor: "parmar",
          tourOptionId: variation?.variation_unique_id,
          startTime: fieldValue?.time?.entry_time || startTime || "",
          exitTime: fieldValue?.time?.exit_time || "",
          commonId: data?.commonId,
        }
      );
      return result ?? {};
    }
    const result = await getAvailability(
      variation?.tourId ?? data?.singleId,
      moment(fieldValue.selectDate).format("YYYY-MM-DD"),
      fieldValue?.numberOfChild ?? 0,
      fieldValue?.numberOfAdults ?? 1,
      fieldValue?.numberOfInfants ?? 0,
      {
        vendor: "rayna",
        contractId: variation?.contractId,
        tourOptionId: variation?.tourOptionId ?? variation?.variation_unique_id,
        transferId: variation?.transferId,
        startTime,
        commonId: data?.commonId,
      }
    );
    return result ?? {};
  };

  useEffect(() => {
    setError("");
    if (selectedVariation?.variation_unique_id !== variation?.variation_unique_id) {
      return;
    }
    if (data?.isHelidubai || !fieldValue?.selectDate) {
      return;
    }
    const isEmaarVendor = data?.isEmaar || data?.isEmaarV1;
    const isRaynaSlot =
      (variation?.vendor === "rayna" || data?.isRayna) && variation?.isSlot;
    const isParmarSlot =
      (variation?.vendor === "parmar" || data?.isParmar) && variation?.isSlot;
    if (!isEmaarVendor && !isRaynaSlot && !isParmarSlot) {
      return;
    }
    setSelected(null);
    setFieldValue({
      ...fieldValue,
      time: "",
    });
    const travelDate = moment(fieldValue.selectDate).format("YYYY-MM-DD");
    if (isEmaarVendor) {
      refreshUnifiedSlots({
        vendor: "emaar",
        isEmaarV1: !!data?.isEmaarV1,
        productId: String(data?.singleId ?? ""),
        excursionVariationId: String(variation?.variation_unique_id ?? ""),
        ResourceID: String(variation?.variation_resource_id ?? "1"),
        StartDateTime: travelDate,
        ...(data?.commonId ? { commonId: data.commonId } : {}),
      });
    } else if (isParmarSlot) {
      const qp = new URLSearchParams(location.search);
      refreshUnifiedSlots({
        vendor: "parmar",
        tourId: String(variation?.tourId ?? data?.singleId ?? ""),
        productId: String(data?.singleId ?? ""),
        variationId: String(variation?.variation_unique_id ?? ""),
        parmarKind: String(variation?.parmarKind ?? data?.parmarKind ?? "single"),
        travelDate,
        countryId: qp.get("country-id") ?? "",
        cityId: qp.get("city-id") ?? "",
        noOfAdult: String(fieldValue?.numberOfAdults ?? 1),
        noOfChild: String(fieldValue?.numberOfChild ?? 0),
        ...(data?.commonId ? { commonId: data.commonId } : {}),
      });
    } else {
      refreshUnifiedSlots({
        vendor: "rayna",
        tourId: String(variation?.tourId ?? ""),
        contractId: String(variation?.contractId ?? ""),
        tourOptionId: String(variation?.tourOptionId ?? variation?.variation_unique_id ?? ""),
        transferId: String(variation?.transferId ?? ""),
        travelDate,
        noOfAdult: String(fieldValue?.numberOfAdults ?? 1),
        noOfChild: String(fieldValue?.numberOfChild ?? 0),
        ...(data?.commonId ? { commonId: data.commonId } : {}),
      });
    }
  }, [selectedVariation?.variation_unique_id, fieldValue?.selectDate, fieldValue?.numberOfAdults, fieldValue?.numberOfChild, fieldValue?.numberOfInfants]);

  useEffect(() => {
    if (
      data?.isHelidubai &&
      selectedVariation?.variation_unique_id === variation?.variation_unique_id
    ) {
      setError("")
      setFieldValue({
        ...fieldValue,
        time: "",
      });
      let totalPax = fieldValue?.numberOfAdults + fieldValue?.numberOfChild + fieldValue?.numberOfInfants
      if (totalPax <= 5) {
        sethelidubaipaxError("")
        setSelected(null);
        refreshHeliDubaiSchedules(
          variation?.variation_unique_id,
          data?.singleId,
          fieldValue?.selectDate,
          selectedVariation?.variation_title,
          fieldValue.numberOfAdults,
          (fieldValue.numberOfChild ?? 0) + (fieldValue.numberOfInfants ?? 0),
          selectedVariation?.IsEventBased
        );
      }
      else {
        sethelidubaipaxError("Maximum 5 passengers allowed for this helicopter ride.")
      }
    }
  }, [
    fieldValue.numberOfAdults,
    fieldValue.numberOfChild,
    selectedVariation?.variation_unique_id,
    fieldValue?.selectDate,
    fieldValue.numberOfInfants,
  ]);

  useEffect(() => {
    if (
      variation?.isCustom &&
      selectedVariation?.variation_unique_id === variation?.variation_unique_id
    ) {
      setSelected(null);
      setError("");
      setFieldValue({
        ...fieldValue,
        time: "",
      });
    }
  }, [fieldValue?.selectDate, fieldValue?.numberOfAdults, fieldValue?.numberOfChild, fieldValue?.numberOfInfants]);

  const labels = {
    "Adults": data?.singleExcursionData?.excursion_ticket_adult_age_limit,
    "Children": data?.singleExcursionData?.excursion_ticket_child_age_limit,
    "Infants": data?.singleExcursionData?.excursion_ticket_infant_age_limit
  }

  // time slots
  let timeSlotarr = [];

  if (
    (variation?.isSlot || data?.isEmaar || data?.isEmaarV1) &&
    !data?.isHelidubai &&
    Array.isArray(timeSlots?.slots)
  ) {
    timeSlotarr = timeSlots.slots.map((slot) => ({
      ...slot,
      Available: slot?.available ?? slot?.Available,
    }));
  } else if (data?.isEmaar || data?.isEmaarV1) {
    timeSlotarr = timeSlots?.ResponseData?.TimeSlots;
  } else if (data?.isHelidubai) {
    timeSlotarr = timeSlots?.slots?.map((slot)=>{
      return {
        ...slot,
        Prices: [
          {
            Price: slot?.pr,
            Type: "Adult",
          },
          {
            Price: slot?.pr,
            Type: "Child",
          },
        ],
        StartDateTime: moment.parseZone(slot?.dt),
        EndDateTime: moment.parseZone(slot?.dt),
        // Available: d?.freeSeats,
      }
    })
  } else if (customProductTimeSlot?.timeSlots) {
    timeSlotarr = customProductTimeSlot?.timeSlots?.map((slot)=>{
      if (slot?.openDay) {
        return {
          ...slot,
          Prices: [
            {
              Price: customProductTimeSlot?.excursionPrice?.adultPrice,
              Type: "Adult",
            },
            {
              Price: customProductTimeSlot?.excursionPrice?.childPrice,
              Type: "Child",
            },
          ],
          StartDateTime: moment(fieldValue.selectDate).format("YYYY-MM-DD"),
        }
      }
      const [hour, minute] = slot?.timeSlot?.split?.(":");
      const paddedTimeSlot = `${hour?.padStart(2, "0")}:${minute?.padStart(2, "0")}`;
      const dateTimeString = `${moment(fieldValue?.selectDate).format("YYYY-MM-DD")} ${paddedTimeSlot}`;
      const startDateTime = moment(dateTimeString).format("YYYY-MM-DD HH:mm");
      return {
        ...slot,
        is_highest : slot?.hourType === "Prime" ? true : false,
        Prices: [
          {
            Price: slot?.adultPrice,
            Type: "Adult",
          },
          {
            Price: slot?.childPrice,
            Type: "Child",
          },
        ],
        StartDateTime: startDateTime,
        EndDateTime: startDateTime,
        Available: slot?.availableSeats,
      }
    })
  } else if (customProductTimeSlot?.length > 0) {
    timeSlotarr = customProductTimeSlot?.map((slot)=>{
      if (slot?.openDay) {
        return {
          ...slot,
          Prices: [
            {
              Price: data?.excursionPrice?.adultPrice,
              Type: "Adult",
            },
            {
              Price: data?.excursionPrice?.childPrice,
              Type: "Child",
            },
          ],
          StartDateTime: moment(fieldValue.selectDate).format("YYYY-MM-DD"),
        }
      }
      const [hour, minute] = slot?.timeSlot?.split?.(":");
      const paddedTimeSlot = `${hour?.padStart(2, "0")}:${minute?.padStart(2, "0")}`;
      const dateTimeString = `${moment(fieldValue?.selectDate).format("YYYY-MM-DD")} ${paddedTimeSlot}`;
      const startDateTime = moment(dateTimeString).format("YYYY-MM-DD HH:mm");
      return {
        ...slot,
        Prices: [
          {
            Price: data?.excursionPrice?.adultPrice,
            Type: "Adult",
          },
          {
            Price: data?.excursionPrice?.childPrice,
            Type: "Child",
          },
        ],
        StartDateTime: startDateTime,
        EndDateTime: startDateTime,
      }
    })
  }
  else {
    timeSlotarr = (selectedVariation?.variations_time_slot ?? []).map?.((d) => {
      let timeToConsider = moment(
        moment(fieldValue.selectDate).set(
          "hours",
          d?.start_time?.split(":")?.[0]
        )
      );
      timeToConsider = moment(
        moment(timeToConsider).set(
          "minutes",
          d?.start_time?.split(":")?.[1]?.split(" ")?.[0]
        )
      );
      return {
        ...d,
        Prices: [
          {
            Price: d?.adult_price,
            Type: "Adult",
          },
          {
            Price: d?.child_price,
            Type: "Child",
          },
        ],
        StartDateTime: timeToConsider,
        EndDateTime: moment(timeToConsider).add(30, "minutes"),
      };
    });
  }

  const isBlockedOnSelectedDate =
    fieldValue.selectDate &&
    variation?.variation_blackout_date?.some?.((d) => {
      return moment(d?.blackout_date).isSame(
        moment(fieldValue.selectDate),
        "date"
      );
    });
  let desc = variation?.variation_description;
  const readMoreEligible = desc?.length > maxDescChars;
  if (readMoreEligible) {
    desc = `${String(variation?.variation_description).slice(
      0,
      toggleReadMore?.[variation?.variation_unique_id]
        ? variation?.variation_description?.length
        : maxDescChars
    )}${
      toggleReadMore?.[variation?.variation_unique_id]
        ? '<span className="hw-black900"> Show less</span>'
        : '<span className="hw-black900"> Read more</span>'
    }`;
  }

  useEffect(()=>{
    if (selectedVariation !== null) {
      const el = variationRefs.current[selectedVariation?.variation_unique_id];
      if (el) {
        const headerOffset = 120;
        const elementPosition = el.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        // el.scrollIntoView({ behavior: "smooth" , });
        window.scrollTo({
          top : offsetPosition,
          behavior : "smooth"
        })
      }
    }
  },[selectedVariation])

  useEffect(() => {
    if (
      isAvailableTicketLessThanSelected &&
      selectedVariation?.variation_unique_id === variation?.variation_unique_id &&
      errorMessageRef.current
    ) {
      const headerOffset = 170;
      const elementPosition = errorMessageRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }, [isAvailableTicketLessThanSelected, selectedVariation?.variation_unique_id, variation?.variation_unique_id]);

  return (
    <div
      className={`hw-excursion--selectSliderItem row d-flex justify-between ${
        selectedVariation?.variation_unique_id ===
        variation?.variation_unique_id
          ? "active"
          : ""
      }`}
      data-processing={processingCheckout ? "true" : undefined}
      onClick={() => {
        setSelected(null);
        if (loading || loadingAPI) {
          return;
        }
        if (isBlockedOnSelectedDate) {
          return;
        }
        _setSelectedVariation(variation);
      }}
    >
      <div
        className="hw-excursion--title col-sm-10 col-lg-6 col-xl-6"
      >
        <div className="d-flex hw-gapxy10 wrap">
          <div className="hw-black900 hw-fontBold no-wrap">{variation?.variation_title}</div>
          {fieldValue?.selectDate && (
            <div className="hw-fontWeight--500 no-wrap">(Selected date : <span className="hw-fontBold">{formatDateFormat(fieldValue?.selectDate)}</span>)</div>
          )}
        </div>
        {desc ? (
          <div className="mt-2"
            onClick={() => {
              setToggleReadMore({
                ...toggleReadMore,
                [variation?.variation_unique_id]:
                  !toggleReadMore?.[variation?.variation_unique_id],
              });
            }}
            dangerouslySetInnerHTML={{
              __html: desc,
            }}
          />
        ) : null}
      </div>

      {/*{variation?.variation_start_price ? (
        <div className="price flex-shrink--null d-flex d-flex-column col-sm-2 col-xl-1">
          <small>From</small>{" "}
          <span className="hw-black900 hw-text18  hw-fontBold">
            {formatePriceFn(agentActiveCurrency , formatPrice(variation?.variation_start_price,true,true), displayPrice)}
          </span>
        </div>
      ) : null}*/}
      {loading ? (
        <div className="hw-main--loaderCommon" />
      ) : helidubaipaxError ? <div className="hw-p-error-cls col-md-12 col-lg-5 col-xl-6" style={{alignContent:"center"}}>{helidubaipaxError}</div>
       : selectedVariation?.variation_unique_id ===
        variation?.variation_unique_id ? (
        <>
          {/* {error && (
            <div className="col-md-12 col-lg-3 col-xl-3">
              <span className="hw-p-error-cls text-right d-flex justify-end hw-excursion--error-cls" >{error}</span>
            </div>
          )} */}
              <div
              ref={(el) => variationRefs.current[variation?.variation_unique_id] = el}
               className={`col-md-12 col-lg-2 col-xl-2 d-flex ${timeSlotarr?.length > 0 ? "hw-excursion--availabilityWrapper" : "hw-excursion--availabilityWrapperNoTimeSlots"}`}>
                {
                  (IsEventBased || customProductTimeSlot?.timeSlots || customProductTimeSlot?.length > 0) ?
                    <>
                      {
                        timeSlotarr?.length > 0 ? (
                          <>
                            <div className="hw-excursion--checkout hw-position--relative d-flex-column ">
                              <button
                                class={`hw-btn hw-btn--lg hw-btn--primary float-right hw-checkout-btn ${!fieldValue?.selectDate && "disabled"}`}
                                disabled={!fieldValue?.selectDate}
                                onClick={async () => {
                                  if(data?.customProductTimeSlotBase){
                                    if(fieldValue?.time?.availableSeparateSeats?.adultSeats < fieldValue?.numberOfAdults || fieldValue?.time?.availableSeparateSeats?.childSeats < fieldValue?.numberOfChild){
                                      setError(
                                        `only ${fieldValue?.time?.availableSeparateSeats?.adultSeats} adult seats and ${fieldValue?.time?.availableSeparateSeats?.childSeats} child seats are available.`
                                      );
                                        return;
                                    }
                                  }
                                  if (
                                    (!fieldValue?.time?.StartDateTime ||
                                    isAvailableTicketLessThanSelected) && !fieldValue?.time?.openDay
                                  ) {
                                    setError("Please select a time slot to continue.")
                                    return;
                                  }
                                  // Block booking a pax type that is selected but priced at 0
                                  // (e.g. child price 0) — those seats are not sellable.
                                  {
                                    const paxEntry = (type) =>
                                      fieldValue?.time?.Prices?.find((x) => x?.Type === type);
                                    const blocked = [];
                                    const eA = paxEntry("Adult");
                                    const eC = paxEntry("Child");
                                    if ((fieldValue?.numberOfAdults ?? 0) > 0 && eA && !(Number(eA.Price) > 0)) blocked.push("Adult");
                                    if ((fieldValue?.numberOfChild ?? 0) > 0 && eC && !(Number(eC.Price) > 0)) blocked.push("Child");
                                    if (blocked.length) {
                                      setError(`${blocked.join(" and ")} seats are not available for this excursion.`);
                                      return;
                                    }
                                  }
                                  const slotData = encodeURIComponent(
                                    btoa(
                                      unescape(
                                        encodeURIComponent(JSON.stringify(fieldValue?.time))
                                      )
                                    )
                                  );
                                  if (data?.isHelidubai) {
                                    const result = fieldValue?.time?.Prices?.reduce((acc, d) => {
                                      if (!d?.Type) return acc;
                                      const key = d?.Type?.toLowerCase();
                                      acc[key] = {
                                        baseAmount: d?.Price,
                                        finalAmount: d?.Price
                                      };
                                      return acc;
                                    }, {});
                                    const pricingObj = btoa(
                                      encodeURIComponent(JSON.stringify(result ?? {}))
                                    );
                                    const url = `eId=${data?.singleId}&vId=${selectedVariation?.variation_unique_id
                                      }&d=${moment(fieldValue.selectDate).format(
                                        "YYYY-MM-DD"
                                      )}&t=${encodeURIComponent(
                                        fieldValue?.time?.StartDateTime
                                      )}&tr=${fieldValue.transfer
                                      }&p=${`${fieldValue.numberOfAdults}n${fieldValue.numberOfChild}n${fieldValue.numberOfInfants}`}&eventId=${fieldValue?.time?.EventID
                                      }&pr=${pricingObj}&taxdata=${taxObj}&et=${fieldValue?.time?.EndDateTime}&tPid=${timeSlots?.scheduleList?.[0]?.tourProductId
                                      }&tSId=${fieldValue?.time?.fn}&tId=${fieldValue?.time?.id
                                      }&tD=${timeSlots?.scheduleList?.[0]?.duration}&jwt=${timeSlots?.jwt ?? ""}&IsEventBased=${true}&slotData=${slotData}&${checkoutContextParams()}`
                                      const session = await createCheckoutSession(url)
                                      if(session?.success){
                                        navigate(`/excursion/checkout?id=${session?.token}`)
                                      } else {
                                        setAvailabilityMessage("Failed to checkout. Please try again.")
                                      }
                                    return;
                                  } else {
                                    const slotStartTime = fieldValue?.time?.timeSlot
                                      ? `${fieldValue.time.timeSlot}:00`.slice(0, 8)
                                      : variation?.startTime ?? "";
                                    setProcessingCheckout(true);
                                    const availabilityCheck = await checkRaynaAvailability(slotStartTime);
                                    if (!availabilityCheck?.success) {
                                      setProcessingCheckout(false);
                                      setError(availabilityCheck?.message || "Tickets are not available for the selected slot.");
                                      return;
                                    }
                                    const result = fieldValue?.time?.Prices?.reduce((acc, d) => {
                                      if (!d?.Type) return acc;
                                      const key = d?.Type?.toLowerCase();
                                      acc[key] = slotTaxBlock(d?.Price, slotVatType.vatRateType, slotVatType.exclusiveOrInclusive);
                                      return acc;
                                    }, {});
                                    const variationPrices =
                                      selectedVariation?.prices ?? variation?.prices;
                                    if (result && !result?.infant && variationPrices?.infant) {
                                      result.infant = variationPrices.infant;
                                    }
                                    const slotVatPrices = fieldValue?.time?.prices;
                                    const pricingObj = btoa(
                                      encodeURIComponent(JSON.stringify(slotVatPrices ?? result ?? {}))
                                    );
                                    const url = `eId=${data?.singleId}&vId=${selectedVariation?.variation_unique_id
                                      }&rId=${selectedVariation?.variation_resource_id}&d=${moment(fieldValue.selectDate).format(
                                        "YYYY-MM-DD"
                                      )}&t=${encodeURIComponent(
                                        fieldValue?.time?.StartDateTime
                                      )}&tr=${fieldValue.transfer
                                      }&p=${`${fieldValue.numberOfAdults}n${fieldValue.numberOfChild}n${fieldValue.numberOfInfants}`}&eventId=${fieldValue?.time?.EventID
                                      }&pr=${pricingObj}&taxdata=${taxObj}&et=${fieldValue?.time?.EndDateTime}&tPid=${timeSlots?.scheduleList?.[0]?.tourProductId
                                      }&tSId=${fieldValue?.time?.tourScheduleId}&tId=${fieldValue?.time?.tourId
                                      }&tD=${timeSlots?.scheduleList?.[0]?.duration}&IsEventBased=${true}&openDay=${fieldValue?.time?.openDay}&eTicket=${selectedVariation?.IsEticketRequired}&vendorBased=${data?.productVendorConfirmationBase}&slotData=${slotData}&${checkoutContextParams()}`
                                      const session = await createCheckoutSession(url)
                                      if(session?.success){
                                        navigate(`/excursion/checkout?id=${session?.token}`)
                                      } else {
                                        setProcessingCheckout(false);
                                        setError("Failed to checkout. Please try again.")
                                      }
                                }
                                }}
                              >
                                Checkout
                              </button>
                              {
                                error && <span className="hw-p-error-cls mt-10 excursion-error-cls" >{error}</span>
                              }
                            </div>
                          </>
                        ) : <div style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                          <div className="hw-fontWeight--500">
                            Timeslots not available.
                          </div>
                        </div>
                      }
                    </> : <div className="hw-excursion--checkout hw-position--relative d-flex-column">
                      <button
                        class={`hw-btn hw-btn--lg hw-btn--primary float-right hw-checkout-btn ${!fieldValue?.selectDate && "disabled"}`}
                        disabled={!fieldValue?.selectDate}
                        onClick={async () => {
                          setProcessingCheckout(true);
                          const availabilityCheck = await checkRaynaAvailability(variation?.startTime ?? "");
                          if (!availabilityCheck?.success) {
                            setProcessingCheckout(false);
                            setError(availabilityCheck?.message || "Tickets are not available for the selected date.");
                            return;
                          }
                          // Block a selected pax type priced at 0 (e.g. child price 0).
                          {
                            const vp = selectedVariation?.prices ?? variation?.prices;
                            const priceFor = (k) => Number(vp?.[k]?.finalAmount ?? vp?.[k]?.baseAmount) || 0;
                            const blocked = [];
                            if ((fieldValue?.numberOfAdults ?? 0) > 0 && vp?.adult && !(priceFor("adult") > 0)) blocked.push("Adult");
                            if ((fieldValue?.numberOfChild ?? 0) > 0 && vp?.child && !(priceFor("child") > 0)) blocked.push("Child");
                            if (blocked.length) {
                              setProcessingCheckout(false);
                              setError(`${blocked.join(" and ")} seats are not available for this excursion.`);
                              return;
                            }
                          }
                          let adult_price = fieldValue?.numberOfAdults > 0 && `Adult_${variation?.variation_start_price}`
                          let child_price = fieldValue?.numberOfChild > 0 && `Child_${variation?.variation_start_price}`
                          let total_price = [adult_price, child_price].filter(Boolean).join("nn")
                          const variationPrices = selectedVariation?.prices ?? variation?.prices;
                          const prValue = variationPrices
                            ? btoa(encodeURIComponent(JSON.stringify(variationPrices)))
                            : total_price;
                          const url = `eId=${data?.singleId}&vId=${selectedVariation?.variation_unique_id
                            }&d=${moment(fieldValue.selectDate).format(
                              "YYYY-MM-DD"
                            )}&t=${encodeURIComponent(
                              fieldValue?.selectDate
                            )}&tr=${fieldValue.transfer
                            }&p=${`${fieldValue.numberOfAdults}n${fieldValue.numberOfChild}n${fieldValue.numberOfInfants}`}&eventId=${fieldValue?.time?.EventID}&pr=${prValue}&taxdata=${taxObj}&et=${fieldValue?.time?.EndDateTime}&tPid=${timeSlots?.scheduleList?.[0]?.tourProductId
                            }&tSId=${fieldValue?.time?.tourScheduleId}&tId=${fieldValue?.time?.tourId
                            }&tD=${timeSlots?.scheduleList?.[0]?.duration}&IsEventBased=${false}&${checkoutContextParams()}`
                          const session = await createCheckoutSession(url)
                          if (session?.success) {
                            navigate(`/excursion/checkout?id=${session?.token}`)
                          } else {
                            setLoadingAPI(false);
                            setError("Failed to checkout. Please try again.")
                          }
                        }}
                      >
                        Checkout
                      </button>
                      {
                        error && <span className="hw-p-error-cls mt-10 excursion-error-cls w-100">{error}</span>
                      }
                    </div>
                }
              </div>
              {
                timeSlotarr?.length > 0 && (
                  <div className="col-md-12">
                    <div className="time-picker-container">
                      {
                        customProductTimeSlot?.length > 0 ? null :<div className="legend">
                        <div className="legend-item">
                          <div className="legend-color prime-color"></div>
                          <div className="legend-item-tooltip">
                            <span className="hw-fontWeight--500">Prime Hours</span>
                            <div className="legend-tooltip">
                              High price, higher demand.
                            </div>
                          </div>
                        </div>
                        <div className="legend-item">
                          <div className="legend-color non-prime-color"></div>
                          <div className="legend-item-tooltip">
                            <span className="hw-fontWeight--500">Non Prime Hours</span>
                            <div className="legend-tooltip">
                              Low price, lower demand.
                            </div>
                          </div>
                        </div>
                        <div className="legend-item">
                          <div className="legend-color low-ticket-color"></div>
                          <div className="legend-item-tooltip">
                            <span className="hw-fontWeight--500 no-wrap">Few Tickets Available / Sold Out</span>
                            <div className="legend-tooltip">
                            Few tickets available, hurry up! / No seats are available. Please choose another slot.
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                      <div className="hw-text16 hw-fontWeight--500 hw-hw-black500 mb-3">Select Time options</div>
                        <div className="time-options-container">
                          <div className="time-grid">
                            {
                              timeSlotarr?.map((slot, index) => {
                                return (
                                  slot?.openDay ? (
                                    <button onClick={(e) => {
                                      setError("")
                                      e.stopPropagation();
                                      setSelected(index)
                                      setFieldValue({
                                        ...fieldValue,
                                        time: slot,
                                      });
                                      setShowTimeSlots(false);
                                    }} className={`time-slot open-date ${(selected === index) ? "selected" : ""}`}><span className="time-grid--topTime"><OpenDateIcon/><span>Open Date</span></span>
                                    </button>
                                  ) : <button
                                    disabled={slot?.Available === 0}
                                    onClick={(e) => {
                                    setError("")
                                    e.stopPropagation();
                                    setSelected(index)
                                    setFieldValue({
                                      ...fieldValue,
                                      time: slot,
                                    });
                                    if(slot?.fewTicketsLeft){
                                      setFewTicketPrice({
                                        childPrice: slot?.childPrice,
                                        adultPrice: slot?.adultPrice,
                                        infantPrice: slot?.infantPrice,
                                      })
                                    }
                                    setShowTimeSlots(false);
                                  }} className={`time-slot ${slot?.fewTicketsLeft ? "low-ticket" : slot?.is_highest ? "prime" : "non-prime"} ${(selected === index) ? "selected" : ""} ${slot?.Available === 0 ? "disabled-slot" : ""}`}><span className="time-grid--topTime"> {
                                    !slot?.openDay ? moment(slot?.StartDateTime).format(
                                      "HH:mm") : ""
                                  }{(slot?.Available != null || slot?.Available != undefined) && (
                                    <span className="time-slot-seats">
                                      {slot?.Available === 0 ? "(Sold out)" : `(${slot?.Available ?? 0} seats)`}
                                    </span>
                                  )}
                                  </span>
                                  </button>
                                )
                              })
                            }
                          </div>
                          <div className="time-options-right">
                            {
                              customProductTimeSlot?.length > 0 ? null : <>
                              {
                              timeSlotarr?.find(p => p?.is_highest) && (
                                <div className="time-options-item">
                                    <div className="legend-item hw-line--pb" style={{ borderBottom: "1px solid #D7D7D7" }}>
                                      <div className="legend-color prime-color"></div>
                                      <span className="hw-text14 hw-fontWeight--500 primecolor">Prime Hours</span>
                                    </div>
                                    <div>
                                      <div className="hw-black hw-black500 hw-text14 time-grid--priceDetails">
                                        {
                                          timeSlotarr?.find(p => p?.is_highest)?.Prices?.find(p => p?.Type === 'Adult')?.Price > 0 && <div className="time-options-item-price"><span>Adult {labels?.Adults ? `(${labels?.Adults})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => p?.is_highest)?.Prices?.find(p => p?.Type === 'Adult')?.Price, false,false,true), displayPrice)}</span></div>
                                        }
                                        {
                                          timeSlotarr?.find(p => p?.is_highest)?.Prices?.find(p => p?.Type === 'Child')?.Price > 0 && <div className="time-options-item-price"><span>Child {labels?.Children ? `(${labels?.Children})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => p?.is_highest)?.Prices?.find(p => p?.Type === 'Child')?.Price, false,false,true), displayPrice)}</span></div>
                                        }
                                        {
                                          timeSlotarr?.find(p => p?.is_highest)?.Prices?.find(p => p?.Type === 'Infant')?.Price > 0 && <div className="time-options-item-price"><span>Infant {labels?.Infants ? `(${labels?.Infants})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => p?.is_highest)?.Prices?.find(p => p?.Type === 'Infant')?.Price, false,false,true), displayPrice)}</span></div>
                                        }
                                      </div>
                                    </div>
                                </div>
                              )
                            }
                            {
                              timeSlotarr?.find(p => (!p?.is_highest && !p?.openDay)) && (
                                <div className="time-options-item">
                                  <div className="legend-item hw-line--pb" style={{ borderBottom: "1px solid #D7D7D7" }}>
                                    <div className="legend-color non-prime-color"></div>
                                    <span className="hw-text14 hw-fontWeight--500 nonprime-color">Non Prime Hours</span>
                                  </div>
                                  <div className="hw-black hw-black500 hw-text14 time-grid--priceDetails">
                                    {
                                      timeSlotarr?.find(p => (!p?.is_highest && !p?.openDay))?.Prices?.find(p => p?.Type === 'Adult')?.Price > 0 && <div className="time-options-item-price"><span>Adult {labels?.Adults ? `(${labels?.Adults})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => !p?.is_highest && !p?.openDay)?.Prices?.find(p => p?.Type === 'Adult')?.Price, false,false,true), displayPrice)}</span></div>
                                    }
                                    {
                                      timeSlotarr?.find(p => (!p?.is_highest && !p?.openDay))?.Prices?.find(p => p?.Type === 'Child')?.Price > 0 && <div className="time-options-item-price"><span>Child {labels?.Children ? `(${labels?.Children})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => !p?.is_highest && !p?.openDay)?.Prices?.find(p => p?.Type === 'Child')?.Price, false,false,true), displayPrice)}</span></div>
                                    }
                                    {
                                      timeSlotarr?.find(p => (!p?.is_highest && !p?.openDay))?.Prices?.find(p => p?.Type === 'Infant')?.Price > 0 && <div className="time-options-item-price"><span>Infant {labels?.Infants ? `(${labels?.Infants})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => !p?.is_highest && !p?.openDay)?.Prices?.find(p => p?.Type === 'Infant')?.Price, false,false,true), displayPrice)}</span></div>
                                    }
                                  </div>
                                </div>
                              )
                            }
                            {
                              timeSlotarr?.find(p =>p?.fewTicketsLeft) && (
                                <div className="time-options-item">
                                  <div className="legend-item hw-line--pb" style={{ borderBottom: "1px solid #D7D7D7" }}>
                                    <div className="legend-color low-ticket-color"></div>
                                    <span className="hw-text14 hw-fontWeight--500 lowticket-color">Few Tickets Available</span>
                                  </div>
                                  <div className="hw-black hw-black500 hw-text14 time-grid--priceDetails">
                                    {
                                      Object.keys(fewTicketPrice).length > 0 ? <> {
                                        fewTicketPrice?.adultPrice > 0 && <div className="time-options-item-price"><span>Adult {labels?.Adults ? `(${labels?.Adults})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(fewTicketPrice?.adultPrice, false,false,true), displayPrice)}</span></div>
                                      }
                                        {
                                          fewTicketPrice?.childPrice > 0 && <div className="time-options-item-price"><span>Child {labels?.Children ? `(${labels?.Children})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(fewTicketPrice?.childPrice, false,false,true), displayPrice)}</span></div>
                                        }
                                        {
                                          fewTicketPrice?.infantPrice > 0 && <div className="time-options-item-price"><span>Infant {labels?.Infants ? `(${labels?.Infants})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(fewTicketPrice?.infantPrice, false,false,true), displayPrice)}</span></div>
                                        }</> : <>
                                        {
                                          timeSlotarr?.find(p => p?.fewTicketsLeft)?.Prices?.find(p => p?.Type === 'Adult')?.Price > 0 && <div className="time-options-item-price"><span>Adult {labels?.Adults ? `(${labels?.Adults})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => p?.fewTicketsLeft)?.Prices?.find(p => p?.Type === 'Adult')?.Price, false,false,true), displayPrice)}</span></div>
                                        }
                                        {
                                          timeSlotarr?.find(p => p?.fewTicketsLeft)?.Prices?.find(p => p?.Type === 'Child')?.Price > 0 && <div className="time-options-item-price"><span>Child {labels?.Children ? `(${labels?.Children})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => p?.fewTicketsLeft)?.Prices?.find(p => p?.Type === 'Child')?.Price, false,false,true), displayPrice)}</span></div>
                                        }
                                        {
                                          timeSlotarr?.find(p => p?.fewTicketsLeft)?.Prices?.find(p => p?.Type === 'Infant')?.Price > 0 && <div className="time-options-item-price"><span>Infant {labels?.Infants ? `(${labels?.Infants})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p => p?.fewTicketsLeft)?.Prices?.find(p => p?.Type === 'Infant')?.Price, false,false,true), displayPrice)}</span></div>
                                        }
                                      </>
                                    }
                                  </div>
                                </div>
                              )
                            }
                              </>
                            }
                            {
                              timeSlotarr?.find(p =>p?.openDay) && (
                                <div className="time-options-item">
                                  <div className="legend-item hw-line--pb" style={{ borderBottom: "1px solid #D7D7D7" }}>

                                    <span className="hw-text14 hw-fontWeight--500 opendate-color"><OpenDateIcon/> Open Date</span>
                                  </div>
                                  <div className="hw-black hw-black500 hw-text14 time-grid--priceDetails">
                                    {
                                      timeSlotarr?.find(p =>p?.openDay)?.Prices?.find(p => p?.Type === 'Adult')?.Price > 0 && <div className="time-options-item-price"><span>Adult {labels?.Adults ? `(${labels?.Adults})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p =>p?.openDay)?.Prices?.find(p => p?.Type === 'Adult')?.Price, false,false,true), displayPrice)}</span></div>
                                    }
                                    {
                                      timeSlotarr?.find(p =>p?.openDay)?.Prices?.find(p => p?.Type === 'Child')?.Price > 0 && <div className="time-options-item-price"><span>Child {labels?.Children ? `(${labels?.Children})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p =>p?.openDay)?.Prices?.find(p => p?.Type === 'Child')?.Price, false,false,true), displayPrice)}</span></div>
                                    }
                                    {
                                      timeSlotarr?.find(p =>p?.openDay)?.Prices?.find(p => p?.Type === 'Infant')?.Price > 0 && <div className="time-options-item-price"><span>Infant {labels?.Infants ? `(${labels?.Infants})` : ""}</span><span className="price hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(timeSlotarr?.find(p =>p?.openDay)?.Prices?.find(p => p?.Type === 'Infant')?.Price, false,false,true), displayPrice)}</span></div>
                                    }
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        </div>
                    </div>
                  </div>
                )
              }
        </>
      ) : null}
      {/* {!loading &&
      selectedVariation?.variation_unique_id ===
        variation?.variation_unique_id &&
      timeSlotarr?.length <= 0 ? (
        <>
          <div className="hw-excursion--pickTime">
            <div className="hw-p-error-cls mb-0 flex-shrink--null">
              {slotError ||
                "Timeslots not available, Please check for another date."}
            </div>
            <div className="hw-select--dropdown"></div>
          </div>
        </>
      ) : null} */}
      {isSelectedVariation &&
      (cancellationPolicyLoading ||
        cancellationPolicyError ||
        cancellationPolicy?.policies?.length > 0 ||
        cancellationPolicy?.html) ? (
        <div className="col-md-12 hw-variation--cancellation" onClick={(e) => e.stopPropagation()}>
          <CancellationPolicy
            data={cancellationPolicy}
            loading={cancellationPolicyLoading}
            error={cancellationPolicyError}
          />
        </div>
      ) : null}
      {processingCheckout ? (
        <div className="hw-excursion--pageLoader">
          <div className="hw-excursion--pageLoaderSpinner" />
        </div>
      ) : null}
      {isAvailableTicketLessThanSelected &&
      selectedVariation?.variation_unique_id ===
        variation?.variation_unique_id ? (
        <p ref={errorMessageRef} className="hw-p-error-cls mb-0">
          The number of selected tickets ({totalSelectedTicketCount}) exceeds
          the available tickets ({fieldValue?.time?.Available}
          ). Please adjust your selection.
        </p>
      ) : null}
    </div>
  );
};

export const VariationSlider = ({
  variations,
  data,
  fieldValue,
  setFieldValue,
  isAvailableTicketLessThanSelected,
  totalSelectedTicketCount,
  customProductTimeSlot=[],
}) => {
  const [selectedVariation, setSelectedVariation] = useState({});
  const [loadingAPI, setLoadingAPI] = useState(false);
  let customTimeSlots = data?.customProductTimeSlots || []

  let customVariation = [
    {
      variation_title: data?.singleTitle,
      variation_unique_id: data?.singleId,
      isCustom: true,
    }
  ]

  let customvariations = (customProductTimeSlot?.timeSlots || customTimeSlots?.length > 0) ? customVariation : variations;

  return (
    <div style={{ width: "100%" }}>
      {customvariations?.map?.((variation, i) => {
        return (
          <VariationItem
            customProductTimeSlot={customProductTimeSlot || customTimeSlots}
            selectedVariation={selectedVariation}
            setSelectedVariation={setSelectedVariation}
            key={i}
            data={data}
            variation={variation}
            fieldValue={fieldValue}
            setFieldValue={setFieldValue}
            isAvailableTicketLessThanSelected={
              isAvailableTicketLessThanSelected
            }
            totalSelectedTicketCount={totalSelectedTicketCount}
            setLoadingAPI={setLoadingAPI}
            loadingAPI={loadingAPI}
          />
        );
      })}
    </div>
  );
};
